import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { HorizontalDivider } from './HorizontalDivider'
import { ThemeMargins } from '../../__styling'

export interface GeneralHorizontalDividerRoutingProps {
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    verticalSpacing?: keyof ThemeMargins
}

export const GeneralHorizontalDividerRegistration = createRegisterableComponent(
    'general-horizontal-divider',
    (props: GeneralHorizontalDividerRoutingProps, _services) => {
        return <HorizontalDivider {...props} />
    },
)
